import { type Schema, createSchema } from 'genson-js';
import { getJsonPathValue } from './json-path';

export type JSONSchema = Readonly<Schema>;

export const createJSONSchema = (
  json: Record<string, unknown>,
  jsonPath: string
): JSONSchema => {
  const value = getJsonPathValue(json, jsonPath);
  return createSchema(value);
};
